import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { useLocation } from 'react-router-dom';
import DesignStore from 'Store/DesignStore';
import fonts from '../Fonts';

interface DynamicStylesProps {
  backgroundColor?: string | null;
  baseColor?: string | null;
  buttonColor?: string | null;
  logoColor?: string | null;
  mainSaleColor?: string | null;
  textColor?: string | null;
  shouldApplyColors?: boolean;
}

const DynamicGlobalStyle = createGlobalStyle<DynamicStylesProps>`
  @font-face {
    font-family: 'Geist';
    src: url(${fonts.GeistVariable}) format('truetype');
    font-weight: 100 900;
    font-style: normal;
    font-display: swap;
  }


  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Instrument Serif';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Instrument Serif Italic';
    src: url(${fonts.InstrumentSerifItalic}) format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }


  :root {
    /* Fonts */
    --font-primary: 'Geist', sans-serif;
    --font-secondary: 'Instrument Serif', serif;
    --font-tertiary: 'Instrument Serif Italic', serif;

    /* Colors - Toujours appliquées */
    /* Utilise des couleurs transparentes par défaut pour éviter le flash noir */
    ${(props) =>
      props.baseColor
        ? `--design-base-color: ${props.baseColor};`
        : '--design-base-color: transparent;'}
    ${(props) =>
      props.buttonColor
        ? `--design-button-color: ${props.buttonColor};`
        : '--design-button-color: transparent;'}
    ${(props) =>
      props.logoColor
        ? `--design-logo-color: ${props.logoColor};`
        : '--design-logo-color: transparent;'}
    ${(props) =>
      props.mainSaleColor
        ? `--design-main-sale-color: ${props.mainSaleColor};`
        : '--design-main-sale-color: transparent;'}

    /* Colors - Uniquement sur /v3/tunnel/recap/ */
    ${(props) =>
      props.shouldApplyColors && props.backgroundColor
        ? `--design-background-color: ${props.backgroundColor};`
        : '--design-background-color: transparent;'}
    ${(props) =>
      props.shouldApplyColors && props.textColor
        ? `--design-text-color: ${props.textColor};`
        : '--design-text-color: transparent;'}
  }

  ${(props) =>
    props.shouldApplyColors && props.backgroundColor
      ? `
    body {
      background-color: ${props.backgroundColor} !important;
    }
  `
      : ''}

  /* Force l'utilisation de la police primaire partout */
  *, *::before, *::after,
  div, span, p, a, button, input, textarea, select, label, h1, h2, h3, h4, h5, h6 {
    /* font-family: var(--font-primary) !important; */
  }
`;

export const DynamicStyles: React.FC = () => {
  const location = useLocation();
  const backgroundColor = DesignStore.useStoreState(
    (state) => state.backgroundColor
  );
  const baseColor = DesignStore.useStoreState((state) => state.baseColor);
  const buttonColor = DesignStore.useStoreState((state) => state.buttonColor);
  const logoColor = DesignStore.useStoreState((state) => state.logoColor);
  const mainSaleColor = DesignStore.useStoreState(
    (state) => state.mainSaleColor
  );
  const textColor = DesignStore.useStoreState((state) => state.textColor);

  // Appliquer les couleurs uniquement sur la page /v3/tunnel/recap/
  const shouldApplyColors =
    location.pathname === '/v3/tunnel/recap' ||
    location.pathname === '/v3/tunnel/recap/' ||
    location.pathname === '/v3/checkout' ||
    location.pathname === '/v3/checkout/';
  // const shouldApplyColors = false;

  return (
    <DynamicGlobalStyle
      shouldApplyColors={shouldApplyColors}
      backgroundColor={backgroundColor}
      baseColor={baseColor}
      buttonColor={buttonColor}
      logoColor={logoColor}
      mainSaleColor={mainSaleColor}
      textColor={textColor}
    />
  );
};
